import { gql } from '@apollo/client'

export const editTenantMutation = gql`
  mutation editTenant($tenantId: ID!, $editTenant: EditTenant!) {
    editTenant(tenantId: $tenantId, editTenant: $editTenant) {
      success
    }
  }
`
